export enum SwipeActionKind {
  Snooze = 'snooze',
  Solve = 'solve',
}

export interface SwipeAction {
  kind: SwipeActionKind;
  label: string;
  icon: string;
}
